import { Suspense } from 'react';
import { Modal as BootstrapModal, Col, Row } from 'react-bootstrap';
import Skeleton, { SkeletonBone } from '../Skeleton/Skeleton';
import ModalActionHeader from './ModalActionHeader';
import '../../../assets/styles/components/Modals.css';
import '../../../assets/styles/components/ModalAction.css';

const Modal = ({
  open,
  onClose,
  modalSize = 'xl',
  height,
  title,
  description,
  content,
  buttons,
  client = false,
  simple = false,
  isInfoModal = false,
  showInfoButton = false,
  onClickInfoButton = () => {},
  customClass = false,
  containerClass = '',
  variant = 'default',
  icon,
  topmost = false
}) => {
  const InfoButton = () => (
    <div className="input-group-append">
      <button className="btn btn-green" title="Info" onClick={onClickInfoButton} type="button" style={{ zIndex: 'unset' }}>
        &#128712;
      </button>
    </div>
  );

  if (variant === 'action') {
    return (
      <BootstrapModal
        show={open}
        onHide={onClose}
        centered
        size={modalSize}
        className={topmost ? 'te-action-modal te-action-modal--topmost' : 'te-action-modal'}
        backdropClassName={topmost ? 'te-action-modal-backdrop te-action-modal-backdrop--topmost' : 'te-action-modal-backdrop'}
      >
        <ModalActionHeader title={title} Icon={icon} onClose={onClose} />
        <div className="te-action-modal-body">
          <Suspense
            fallback={
              <Skeleton>
                <SkeletonBone className="te-action-modal-bone" />
              </Skeleton>
            }
          >
            {content}
          </Suspense>
        </div>
      </BootstrapModal>
    );
  }

  if (isInfoModal) {
    return (
      <Row>
        <Col md={10} className="info-modal" disabled>
          <p>{content}</p>
        </Col>
        {showInfoButton && <InfoButton />}
      </Row>
    );
  }

  return (
    <BootstrapModal show={open} onHide={onClose} centered size={modalSize} backdrop={client ? 'static' : true} keyboard={!client}>
      {!simple ? (
        <>
          <BootstrapModal.Header closeButton>
            <BootstrapModal.Title>{title}</BootstrapModal.Title>
          </BootstrapModal.Header>
          <BootstrapModal.Body className={containerClass || ''} style={{ height, overflowY: containerClass ? 'hidden' : 'scroll' }}>
            {description || content}
          </BootstrapModal.Body>
          {buttons && <BootstrapModal.Footer className="mx-auto text-center">{buttons}</BootstrapModal.Footer>}
        </>
      ) : (
        <BootstrapModal.Body className={`py-2 te-modal-simple-body ${customClass ? 'modal-body-content' : ''} ${containerClass}`}>
          <h2 className="modal-title text-center">{title}</h2>
          {!client && (
            <button type="button" onClick={onClose} className="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          )}
          {content}
        </BootstrapModal.Body>
      )}
    </BootstrapModal>
  );
};

export default Modal;
